import { render, staticRenderFns } from "./CasesDurationChart.vue?vue&type=template&id=7f2d3969"
import script from "./CasesDurationChart.vue?vue&type=script&lang=js"
export * from "./CasesDurationChart.vue?vue&type=script&lang=js"
import style0 from "./CasesDurationChart.vue?vue&type=style&index=0&id=7f2d3969&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports